import { translate } from '../../../common/utility/DisplayPrep';
const { READ_ONLY_FEATURES } = process.env;

const actions = READ_ONLY_FEATURES === 'true' ? ['edit'] : ['edit', 'delete'];

export const uiConfig = {
    name: 'Parameters',
    withActions: [...actions],
    primaryKey: 'uuid',
    pageSize: 10,
    properties: {
        paramId: {
            name: 'ID',
            sortable: true,
            rowDisplay: false,
            input: (v) => {
                return typeof v.paramId !== 'undefined' ? 'valueDisplay' : null;
            }
        },
        resourceId: {
            name: 'Resource ID',
            rowDisplay: false,
            sortable: true
        },
        name: {
            name: 'Name',
            sortable: true,
            rowDisplay: true,
            max: 512,
            min: 0,
            input: 'text'
        },
        description: {
            name: 'Description',
            defaultContent: '',
            min: 0,
            max: 2048,
            rowDisplay: false,
            sortable: true,
            input: 'multiline'
        },
        classType: {
            name: 'Class Type',
            sortable: true,
            rowDisplay: true,
            nullable: false,
            input: 'select'
        },
        uuid: {
            rowDisplay: false,
            sortable: true,
            name: 'Uuid'
        },
        lastModId: {
            rowDisplay: false,
            sortable: true,
            name: 'Last Modified ID'
        },
        lastModDatetime: {
            rowDisplay: false,
            displayPrep: 'FullDate',
            name: 'Last Modified Datetime',
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        createId: {
            rowDisplay: false,
            name: 'Create ID'
        },
        createDatetime: {
            rowDisplay: false,
            name: 'Create Datetime'
        },
        auditId: {
            defaultContent: '',
            sortable: true,
            rowDisplay: false,
            name: 'Audit ID'
        }
    },
    newDoc: {
        createDatetime: '',
        createId: '',
        dtoState: 'NEW',
        lastModDatetime: '',
        lastModId: '',
        name: '',
        resourceId: '',
        classType: undefined
    }
};

export default uiConfig;
